<template>
  <div class="wf-relative" :style="sliderStyles">
    <div class="wf-h-full">
      <div class="wf-flex wf-flex-row wf-flex-no-wrap wf-overflow-x-hidden wf-h-full">
        <div
          v-for="img in images"
          :key="img.id"
          class="wf-flex-1 wf-slider-item"
        >
          <img
            :src="img.url"
            :alt="img.alt"
            :class="contentClasses" class="wf-h-full"
          />
        </div>
      </div>
    </div>
    <button
      v-if="images.length"
      @click.prevent="showPreviousSlide"
      class="wf-w-8 wf-h-8 wf-absolute focus:wf-outline-none wf-left-0 wf-my-auto wf-ml-2 wf-inset-y-0"
      :class="buttonClasses"
      :style="buttonStyles"
    >
      <i class="fas fa-chevron-left"></i>
    </button>
    <button
      v-if="images.length"
      @click.prevent="showNextSlide"
      class="wf-w-8 wf-h-8 wf-absolute focus:wf-outline-none wf-right-0 wf-my-auto wf-mr-2 wf-inset-y-0"
      :class="buttonClasses"
      :style="buttonStyles"
    >
      <i class="fas fa-chevron-right"></i>
    </button>
    <nav v-show="images.length" class="wf-absolute wf-bottom-0 wf-inset-x-0 wf-full wf-mb-5">
      <ul class="wf-flex wf-full wf-items-center wf-justify-center">
        <li
          class="wf-mx-2"
          v-for="(entry, index) in imagesEntries"
          :key="index"
        >
          <button :class="dotsClasses" :style="elementDotsStyles(index)"></button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sliderPosition: 0,
      entries: []
    };
  },

  props: {
    device: {
      type: String,
      default: 'desktop'
    },
    items: {
      type: [Array, Object],
      default: () => []
    },
    numberImages: {
      type: [Number, String],
      default: 3
    },
    sliderStyles: {
      type: [Array, Object],
      default: () => []
    },
    contentClasses: {
      type: Array,
      default: () => []
    },
    buttonClasses: {
      type: Array,
      default: () => []
    },
    buttonStyles: {
      type: [Array, Object],
      default: () => []
    },
    dotsClasses: {
      type: Array,
      default: () => []
    },
    dotsStyles: {
      type: [Array, Object],
      default: () => {}
    },
    activeDotStyles: {
      type: Object,
      default: () => {}
    }
  },

  mounted() {
    this.entries = this.chunkEntries(this.items, this.numberImages);
  },

  computed: {
    images: {
      get() {
        let entries = this.chunkEntries(this.items, this.numberImages);
        return entries.length ? entries[this.sliderPosition] : [];
      },
      set(value) {
        return value;
      }
    },
    imagesEntries() {
      return this.chunkEntries(this.items, this.numberImages)
    }
  },

  methods: {
    chunkEntries(arr, n) {
      return arr.length ? [arr.slice(0, n), ...this.chunkEntries(arr.slice(n), n)] : [];
    },
    elementDotsStyles(slide) {
      if(slide !== this.sliderPosition) {
        return {...this.dotsStyles}
      }
      return {...this.dotsStyles, ...this.activeDotStyles}
    },
    showPreviousSlide() {
      if (!this.imagesEntries.length) {
        return;
      }

      if (this.entries.length < this.sliderPosition - 1 || this.sliderPosition > 0) {
        this.sliderPosition = this.sliderPosition - 1;
      } else {
        this.sliderPosition = this.entries.length - 1;
      }

      this.images = this.entries[this.sliderPosition];
    },
    showNextSlide() {
      if (!this.imagesEntries.length) {
        return;
      }

      this.sliderPosition = this.entries.length > this.sliderPosition + 1 ? this.sliderPosition + 1 : 0;

      this.images = this.entries[this.sliderPosition];
    }
  }
};
</script>

<style lang="css" scoped>
.wf-slider-item {transition: opacity 0.6s ease-out;}
</style>
